export enum PolicyType {
  PRIVACY = "privacy",
  TERMS_OF_SERVICE = "terms_of_service",
}
